import { render, staticRenderFns } from "./ChatterEdit.vue?vue&type=template&id=5f5baea0&scoped=true"
import script from "./ChatterEdit.vue?vue&type=script&lang=js"
export * from "./ChatterEdit.vue?vue&type=script&lang=js"
import style0 from "./ChatterEdit.vue?vue&type=style&index=0&id=5f5baea0&prod&lang=css"
import style1 from "./ChatterEdit.vue?vue&type=style&index=1&id=5f5baea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5baea0",
  null
  
)

export default component.exports